import { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../firebase/firebase";
import { Link } from "react-router-dom";
import "../../assets/css/admin/forgotPassword.css";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const resetPassword = async () => {
    if (!email) {
      setMessage("Please enter your email address.");
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      setMessage("Password reset email has been sent. Please check your inbox.");
    } catch (error) {
      setMessage(error.message.replace("Firebase: ", ""));
    }
  };

  return (
    <div className="forgot-page">
      <div className="forgot-card">
        <h2>Forgot Password</h2>
        <p className="subtitle">
          Enter your email to receive a password reset link.
        </p>

        <input
          type="email"
          placeholder="Email Address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <button onClick={resetPassword}>
          Send Reset Email
        </button>

        {message && <p className="message">{message}</p>}

        <p className="bottom-text">
          Remember your password?
          <Link to="/admin/login"> Login</Link>
        </p>
      </div>
    </div>
  );
}

export default ForgotPassword;